export default "__VITE_ASSET__CSRp7TV1__";